import ctx from '../../plugins/axios';

/**
 * Acquire or release the lock on a specialty list.
 * Acquire: pass { locked_by: userUUID, locked_at: isoString, updated_by: userUUID }
 * Release: pass { locked_by: '',       locked_at: '',          updated_by: userUUID }
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default async ({ listUUID, lockPayload }) => {
  return await ctx.put(`/specialty_list/${listUUID}`, lockPayload);
};
